"use client";

import Link from "next/link";
import { Button } from "./ui/button";
import { MoveLeft } from "lucide-react";
import CardImage from "./ui/CardImage";
import { getImageUrl } from "@/lib/utils/image";
import { getCategoryHref } from "@/lib/navigation/productCategories";

export default function CategoryCard({ category, priority = false }) {
    const product = category.products?.[0];
    const productImage = product?.images?.[0];
    const imageUrl = getImageUrl(productImage || category.image || category.thumbnail);

    return (
        <div className="w-[320px] lg:w-[395px] rounded-3xl p-4 pb-6 lg:p-6 lg:pb-8 glass-box relative mx-auto flex flex-col h-full">
             <div className="relative w-full flex justify-center flex-shrink-0">
                <CardImage src={imageUrl} alt={category.title} priority={priority} />
            </div>

            <div className="w-full flex flex-col justify-between gap-2 lg:mt-5 flex-1">
                <div>
                    <h3 className="text-base lg:text-lg font-semibold mb-1 lg:mb-3 line-clamp-1">{category.title}</h3>
                    <div className="text-mute text-sm line-clamp-3 mt-4 ">{category.description}</div>
                </div>

                <div className="flex justify-between items-end">
                    {category.title_en ? (
                    <Link href={getCategoryHref(category.title_en)}>
                        <Button className="justify-between w-fit font-semibold" variant="whiteBorder" size="lg">
                            مشاهده دسته بندی
                            <MoveLeft className="text-white" />
                        </Button>
                    </Link>
                    ) : null}
                </div>
            </div>
        </div>
    );
}
